export default "__VITE_ASSET__a55302ed__"